export function getLocationHostDomain(): string {
	 const [ hostDomain ] = (/\w+\.\w+$/u).exec(location.host) ?? [];

	return hostDomain ? hostDomain : 'localhost';
}
